import { useNavigate } from 'react-router-dom'

import { PageHeader } from '../../app/PageHeader'
import copyJson from '../../demo/fixtures/copy.json'
import { Button, Icon } from '../../ui'
import { AutopilotOverviewCard } from './AutopilotOverviewCard'
import { CreativeProgressCard } from './CreativeProgressCard'
import { HealthCard } from './HealthCard'
import { NoticesCard } from './NoticesCard'
import { QuickStartCard } from './QuickStartCard'
import { RecentTasksCard } from './RecentTasksCard'
import { TodayCard } from './TodayCard'
import { TodoCard } from './TodoCard'
import { TrendMiniCard } from './TrendMiniCard'
import styles from './index.module.css'

export function OverviewPage() {
  const navigate = useNavigate()

  return (
    <>
      <PageHeader
        data-scope="overview-header"
        title={copyJson.pages.overview.title}
        subtitle={copyJson.pages.overview.subtitle}
        action={(
          <Button onClick={() => { void navigate('/create') }}>
            <Icon name="plus-circle" size={18} />
            创建广告
          </Button>
        )}
      />
      <div className={styles.twoColumn}>
        <div className={styles.column}>
          <TodayCard />
          <TrendMiniCard />
          <RecentTasksCard />
          <div className={styles.pairRow}>
            <QuickStartCard />
            <CreativeProgressCard />
          </div>
          <NoticesCard />
        </div>
        <div className={styles.column}>
          <TodoCard />
          <AutopilotOverviewCard />
          <HealthCard />
        </div>
      </div>
    </>
  )
}
